// extracted by mini-css-extract-plugin
export var HeaderColumn = "happyspizza-module--HeaderColumn--96b64";
export var HeaderRow = "happyspizza-module--HeaderRow--ddcef";
export var HideOnMobile = "happyspizza-module--HideOnMobile--29561";
export var HideOnTablet = "happyspizza-module--HideOnTablet--011c8";